import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import React, { lazy } from "react";
import Login from "../Login/Login";
import LoginChoice from "../Login/LoginChoice";
import RouterErrorPage from "./RouterErrorPage";
import SideBar from "../Layouts/SideBar";
import { checkAuthToken } from "../../common/ApiUtility";
import MediaProformaInvoiceForBuyer from "../OrderRequests/MediaProformaInvoiceForBuyer.jsx";
import MediaProformaInvoiceForSeller from "../OrderRequests/MediaProformaInvoiceForSeller.jsx";
import PrintMediaInventoryBuying from "../../Inventory/PrintMediaInventoryBuying.jsx";
const Landing = lazy(() => import("../Analytics/Landing"));
const AdminDefaultRedirect = lazy(() => import("../Layouts/AdminDefaultRedirect"));
const CompanyListingApprovals = lazy(() => import("../Company/CompanyListingApprovals"));
const AllProductApprovals = lazy(() => import("../Company/AllProductApprovals"));
const Marketplace = lazy(() => import("../Marketplace/Marketplace"));
const ViewProduct = lazy(() => import("../Marketplace/ProductPreviewPage.jsx"));
const MediaProduct = lazy(() => import("../Marketplace/MediaViewProduct/MediaPreviewPage.jsx"));
const ValueandGiftVoucher = lazy(() => import("../Marketplace/VoucherViewProduct/ValueandGiftVoucher"));
const SpacificVoucher = lazy(() => import("../Marketplace/VoucherViewProduct/VoucherPreview.jsx"));
const ProductTrash = lazy(() => import("../Trash/ProductTrash"));
const GenieAdmin = lazy(() => import("../Genie/GenieAdmin"));
const GenieCategory = lazy(() => import("../Genie/GenieCategory"));
const GenieNeedList = lazy(() => import("../Genie/GenieNeedList"));
const GenieActiveInavtive = lazy(() => import("../Genie/GenieActiveInavtive"));
const GenieBingoDeals = lazy(() => import("../Genie/GenieBingoDeals"));
const CompanyLanding = lazy(() => import("../Company/CompanyLanding"));
const Memberlisting = lazy(() => import("../Memberdirectory/Memberlisting"));
const Memberdetails = lazy(() => import("../Adminhandles/Memberdetails"));
const RolesAndPermissionPerticular = lazy(() => import("../Company/RolesAndPermissionPerticular"));
const AllExternalApi = lazy(() => import("../ExternalAPIs/AllExternalApi"));
const SignzyData = lazy(() => import("../ExternalAPIs/SignzyData"));
const VendorApiUsage = lazy(() => import("../ExternalAPIs/VendorApiUsage"));
const PineLabsData = lazy(() => import("../ExternalAPIs/PineLabsData"));
const PickrrData = lazy(() => import("../ExternalAPIs/PickrrData"));
const AllRecords = lazy(() => import("../AllRecords/AllRecords.jsx"));
const Invoices = lazy(() => import("../AllRecords/Invoices"));
const CompanyInvoiceDetail = lazy(() => import("../AllRecords/CompanyInvoiceDetail"));
const InvoiceDetail = lazy(() => import("../AllRecords/InvoicesDetail"));
const Wishlist = lazy(() => import("../AllRecords/Wishlist"));
const Approvals = lazy(() => import("../AllRecords/Approvals"));
const Dashboard = lazy(() => import("../../components/Dashboard/Dashboard"));
const NeedsAttention = lazy(() => import("../../components/Dashboard/NeedsAttention"));
const NeedsAttentionList = lazy(() => import("../../components/Dashboard/NeedsAttentionList"));
const LedgerReconciliation = lazy(() => import("../../components/Dashboard/LedgerReconciliation"));
const NotificationMonitor = lazy(() => import("../../components/Notifications/NotificationMonitor"));
const MembershipList = lazy(() => import("../../View/MembershipList.jsx"));
const MembershipReneval = lazy(() => import("../../View/MembershipReneval.jsx"));
const ViewInvoice = lazy(() => import("../../View/ViewInvoice.jsx"));
const CommissionList = lazy(() => import("../../View/CommisionList.jsx"));
const MemAmountDebitStatus = lazy(() => import("../../View/MemAmountDebitStatus.jsx"));
const Tds_gst = lazy(() => import("../TDS_GST/Tds_gst.jsx"));
const UploadBanner = lazy(() => import("../Dashboard/UploadBanner.jsx"));
const BXICommissionList = lazy(() => import("../AllRecords/Allinvoicedetail/BXICommissionList.jsx"));
const BWTDSDebitNoteList = lazy(() => import("../../View/BWTDSDebitNote/BWTDSDebitNoteList.jsx"));
const BWTDSDebitNoteDetail = lazy(() => import("../../View/BWTDSDebitNote/BWTDSDebitNoteDetail.jsx"));
const BrandWorldTaxInvoiceList = lazy(() => import("../../View/BrandWorldTaxInvoice/BrandWorldTaxInvoiceList.jsx"));
const BrandWorldTaxInvoiceDetail = lazy(() => import("../../View/BrandWorldTaxInvoice/BrandWorldTaxInvoiceDetail.jsx"));
const BulkUploadApprovals = lazy(() => import("../BulkUpload/BulkUploadApprovals.jsx"));
const MultiplexMediaPage = lazy(() => import("../Marketplace/MediaViewProduct/MultiplexMediaPage.jsx"));
const HoardingMediaPreviewPage = lazy(() => import("../Marketplace/MediaViewProduct/HoardingMediaPreviewPage.jsx"));
const Inventory = lazy(() => import("../../Inventory/Inventory.jsx"));
const BXIInventory = lazy(() => import("../../Inventory/BXIInventory.jsx"));
const MultiplexInventoryBuy = lazy(() => import("../../Inventory/MultiplexInventoryBuy.jsx"));
const MediaInventoryBuy = lazy(() => import("../../Inventory/MediaInventoryBuy.jsx"));
const AirportInventoryBuy = lazy(() => import("../../Inventory/AirportInventoryBuy.jsx"));
const HoardingInventoryBuy = lazy(() => import("../../Inventory/HoardingInventoryBuy.jsx"));
const DoohInventoryBuy = lazy(() => import("../../Inventory/DoohInventoryBuy.jsx"));
const InwardMovement = lazy(() => import("../../Inventory/InwardMovement.jsx"));
const OutwardMovement = lazy(() => import("../../Inventory/OutwardMovement.jsx"));
const NetMovement = lazy(() => import("../../Inventory/NetMovement.jsx"));
const TotalProducts = lazy(() => import("../../Inventory/TotalProducts.jsx"));
const ProductDetail = lazy(() => import("../../Inventory/ProductDetail.jsx"));
const CompanyDetails = lazy(() => import("../../Inventory/CompanyDetails.jsx"));
const BXIWallet = lazy(() => import("../Wallet/BXIWallet"));
const AdminOrderRequestDetail = lazy(() => import("../OrderRequests/AdminOrderRequestDetail"));
const AdminPerformaInvoiceView = lazy(() => import("../OrderRequests/AdminPerformaInvoiceView"));
const AdminChooseTransport = lazy(() => import("../OrderRequests/AdminChooseTransport"));
const AdminTaxInvoiceView = lazy(() => import("../OrderRequests/AdminTaxInvoiceView"));
const AdminCommissionInvoiceView = lazy(() => import("../OrderRequests/AdminCommissionInvoiceView"));
const BWWalletTransactions = lazy(() => import("../Wallet/BWWalletTransactions"));
const SellerPayoutsReport = lazy(() => import("../Wallet/SellerPayoutsReport"));
const OfflinePaymentsQueue = lazy(() => import("../BrandWorldPayments/OfflinePaymentsQueue"));
const BeneficiaryQueue = lazy(() => import("../BrandWorldPayments/BeneficiaryQueue"));
const BrandWorldPaymentSettings = lazy(() => import("../BrandWorldPayments/BrandWorldPaymentSettings"));
const ProductOrders = lazy(() => import("../AllRecords/ProductOrders.jsx"));
const AdminNotifications = lazy(() => import("../Notifications/AdminNotifications.jsx"));
const HelpAndFeedbackList = lazy(() => import("../HelpAndFeedback/HelpAndFeedbackList.jsx"));
const LeadsPage = lazy(() => import("../BxiAdmin/LeadsPage.jsx"));
const MembersPage = lazy(() => import("../BxiAdmin/MembersPage.jsx"));
const LiveMembersPage = lazy(() => import("../BxiAdmin/LiveMembersPage.jsx"));
const MembershipRenewalsPage = lazy(() => import("../BxiAdmin/MembershipRenewalsPage.jsx"));
const MembershipRevenuePage = lazy(() => import("../BxiAdmin/MembershipRevenuePage.jsx"));
const InventoryValuationPage = lazy(() => import("../BxiAdmin/InventoryValuationPage.jsx"));
const BxiTransactionsPage = lazy(() => import("../BxiAdmin/BxiTransactionsPage.jsx"));
const BWSalesPage = lazy(() => import("../BxiAdmin/BWSalesPage.jsx"));
const BWPurchasePage = lazy(() => import("../BxiAdmin/BWPurchasePage.jsx"));
const BxiProductsPage = lazy(() => import("../BxiAdmin/BxiProductsPage.jsx"));
const LiveProductsPage = lazy(() => import("../BxiAdmin/LiveProductsPage.jsx"));
const PendingProductsPage = lazy(() => import("../BxiAdmin/PendingProductsPage.jsx"));
const DelistedProductsPage = lazy(() => import("../BxiAdmin/DelistedProductsPage.jsx"));
const BxiHandlesPage = lazy(() => import("../BxiAdmin/BxiHandlesPage.jsx"));
const BxiEInvoicesPage = lazy(() => import("../BxiAdmin/BxiEInvoicesPage.jsx"));
const routesData = createBrowserRouter(
  [
    {
      path: "/",
      element: <LoginChoice />,
      errorElement: <RouterErrorPage />,
    },
    {
      path: "/login",
      element: <LoginChoice />,
      errorElement: <RouterErrorPage />,
    },
    {
      path: "/login/bxi",
      element: <Login />,
      errorElement: <RouterErrorPage />,
    },
    {
      path: "/login/brand-world",
      element: <Login />,
      errorElement: <RouterErrorPage />,
    },
    {
      path: "admindashboard",
      element: <SideBar />,
      errorElement: <RouterErrorPage />,
      loader: checkAuthToken,
      children: [
        {
          index: true,
          element: <AdminDefaultRedirect />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "analytics",
          element: <Landing />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "banner",
          element: <UploadBanner />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "tdsgst",
          element: <Tds_gst />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "helpandfeedback",
          element: <HelpAndFeedbackList />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "userdashboard",
          element: <Dashboard />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "needs-attention",
          element: <NeedsAttention />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "needs-attention/:bucketKey",
          element: <NeedsAttentionList />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "ledger-reconciliation",
          element: <LedgerReconciliation />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "notification-monitor",
          element: <NotificationMonitor />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "leads",
          element: <LeadsPage />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "members",
          element: <MembersPage />,
          errorElement: <RouterErrorPage />,
          children: [
            {
              index: true,
              element: <Navigate to="live-members" replace />,
            },
            {
              path: "live-members",
              element: <LiveMembersPage />,
              errorElement: <RouterErrorPage />,
            },
            {
              path: "membership-renewals",
              element: <MembershipRenewalsPage />,
              errorElement: <RouterErrorPage />,
            },
          ],
        },
        {
          path: "transactions",
          element: <BxiTransactionsPage />,
          errorElement: <RouterErrorPage />,
          children: [
            {
              index: true,
              element: <Navigate to="bw-sales" replace />,
            },
            {
              path: "bw-sales",
              element: <BWSalesPage />,
              errorElement: <RouterErrorPage />,
            },
            {
              path: "bw-purchase",
              element: <BWPurchasePage />,
              errorElement: <RouterErrorPage />,
            },
          ],
        },
        {
          path: "revenue",
          element: <MembershipRevenuePage />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "inventory-valuation",
          element: <InventoryValuationPage />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "products",
          element: <BxiProductsPage />,
          errorElement: <RouterErrorPage />,
          children: [
            {
              index: true,
              element: <Navigate to="live" replace />,
            },
            {
              path: "live",
              element: <LiveProductsPage />,
              errorElement: <RouterErrorPage />,
              children: [
                {
                  path: "viewproduct/:id",
                  element: <ViewProduct />,
                  errorElement: <RouterErrorPage />,
                },
                {
                  path: "mediaviewproduct/:id",
                  element: <MediaProduct />,
                  errorElement: <RouterErrorPage />,
                },
                {
                  path: "multiplexmediaviewproduct/:id",
                  element: <MultiplexMediaPage />,
                  errorElement: <RouterErrorPage />,
                },
                {
                  path: "hoardingmediaviewproduct/:id",
                  element: <HoardingMediaPreviewPage />,
                  errorElement: <RouterErrorPage />,
                },
                {
                  path: "valueandgiftvoucher/:id",
                  element: <ValueandGiftVoucher />,
                  errorElement: <RouterErrorPage />,
                },
                {
                  path: "spacificvoucher/:id",
                  element: <SpacificVoucher />,
                  errorElement: <RouterErrorPage />,
                },
              ],
            },
            {
              path: "pending",
              element: <PendingProductsPage />,
              errorElement: <RouterErrorPage />,
              children: [
                {
                  path: "viewproduct/:id",
                  element: <ViewProduct />,
                  errorElement: <RouterErrorPage />,
                },
                {
                  path: "mediaviewproduct/:id",
                  element: <MediaProduct />,
                  errorElement: <RouterErrorPage />,
                },
                {
                  path: "multiplexmediaviewproduct/:id",
                  element: <MultiplexMediaPage />,
                  errorElement: <RouterErrorPage />,
                },
                {
                  path: "hoardingmediaviewproduct/:id",
                  element: <HoardingMediaPreviewPage />,
                  errorElement: <RouterErrorPage />,
                },
                {
                  path: "valueandgiftvoucher/:id",
                  element: <ValueandGiftVoucher />,
                  errorElement: <RouterErrorPage />,
                },
                {
                  path: "spacificvoucher/:id",
                  element: <SpacificVoucher />,
                  errorElement: <RouterErrorPage />,
                },
              ],
            },
            {
              path: "delisted",
              element: <DelistedProductsPage />,
              errorElement: <RouterErrorPage />,
              children: [
                {
                  path: "viewproduct/:id",
                  element: <ViewProduct />,
                  errorElement: <RouterErrorPage />,
                },
                {
                  path: "mediaviewproduct/:id",
                  element: <MediaProduct />,
                  errorElement: <RouterErrorPage />,
                },
                {
                  path: "multiplexmediaviewproduct/:id",
                  element: <MultiplexMediaPage />,
                  errorElement: <RouterErrorPage />,
                },
                {
                  path: "hoardingmediaviewproduct/:id",
                  element: <HoardingMediaPreviewPage />,
                  errorElement: <RouterErrorPage />,
                },
                {
                  path: "valueandgiftvoucher/:id",
                  element: <ValueandGiftVoucher />,
                  errorElement: <RouterErrorPage />,
                },
                {
                  path: "spacificvoucher/:id",
                  element: <SpacificVoucher />,
                  errorElement: <RouterErrorPage />,
                },
              ],
            },
          ],
        },
        {
          path: "handles",
          element: <BxiHandlesPage />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "e-invoices",
          element: <BxiEInvoicesPage />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "inventory",
          element: <Inventory />,
          errorElement: <RouterErrorPage />,
          index: true,
        },
        {
          path: "stock-inventory",
          element: <Inventory />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "bw-marketplace",
          element: <BXIInventory />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "bw-marketplace/multiplex-buy/:id",
          element: <MultiplexInventoryBuy />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "bw-marketplace/multiplexmediabuying/:id",
          element: <MultiplexInventoryBuy />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "bw-marketplace/mediabuying/:id",
          element: <MediaInventoryBuy />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "bw-marketplace/printmediabuying/:id",
          element: <PrintMediaInventoryBuying />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "bw-marketplace/digitalAndHoardingMediaBuying/:id",
          element: <MediaInventoryBuy />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "bw-marketplace/airportmediabuying/:id",
          element: <AirportInventoryBuy />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "bw-marketplace/hoardingmediabuying/:id",
          element: <HoardingInventoryBuy />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "bw-marketplace/doohmediabuying/:id",
          element: <DoohInventoryBuy />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "inward-movement",
          element: <InwardMovement />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "outward-movement",
          element: <OutwardMovement />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "net-movement",
          element: <NetMovement />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "total-products",
          element: <TotalProducts />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "product_detail/:productId",
          element: <ProductDetail />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "CompanyDetails",
          element: <CompanyDetails />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "companies",
          element: <Navigate to="/admindashboard/leads" replace />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "bxi_marketplace",
          element: <Marketplace />,
          errorElement: <RouterErrorPage />,
          children: [
            {
              path: "viewproduct/:id",
              element: <ViewProduct />,
              errorElement: <RouterErrorPage />,
            },
            {
              path: "mediaviewproduct/:id",
              element: <MediaProduct />,
              errorElement: <RouterErrorPage />,
            },
            {
              path: "multiplexmediaviewproduct/:id",
              element: <MultiplexMediaPage />,
              errorElement: <RouterErrorPage />,
            },
            {
              path: "hoardingmediaviewproduct/:id",
              element: <HoardingMediaPreviewPage />,
              errorElement: <RouterErrorPage />,
            },
            {
              path: "valueandgiftvoucher/:id",
              element: <ValueandGiftVoucher />,
              errorElement: <RouterErrorPage />,
            },
            {
              path: "spacificvoucher/:id",
              element: <SpacificVoucher />,
              errorElement: <RouterErrorPage />,
            },
          ],
        },
        {
          path: "bulkuploadapproval",
          element: <BulkUploadApprovals />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "marketplace/viewproduct/:id",
          element: <ViewProduct />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "marketplace/mediaviewproduct/:id",
          element: <MediaProduct />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "marketplace/multiplexmediaviewproduct/:id",
          element: <MultiplexMediaPage />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "marketplace/hoardingmediaviewproduct/:id",
          element: <HoardingMediaPreviewPage />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "marketplace/valueandgiftvoucher/:id",
          element: <ValueandGiftVoucher />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "marketplace/spacificvoucher/:id",
          element: <SpacificVoucher />,
          errorElement: <RouterErrorPage />,
        },

        {
          path: "companylanding/:id",
          element: <CompanyLanding />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "approvallisting",
          element: <CompanyListingApprovals />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "allproductapprovals/:companyId",
          element: <AllProductApprovals />,
          errorElement: <RouterErrorPage />,
          children: [
            {
              path: "viewproduct/:id",
              element: <ViewProduct />,
              errorElement: <RouterErrorPage />,
            },
            {
              path: "mediaviewproduct/:id",
              element: <MediaProduct />,
              errorElement: <RouterErrorPage />,
            },
            {
              path: "multiplexmediaviewproduct/:id",
              element: <MultiplexMediaPage />,
              errorElement: <RouterErrorPage />,
            },
            {
              path: "hoardingmediaviewproduct/:id",
              element: <HoardingMediaPreviewPage />,
              errorElement: <RouterErrorPage />,
            },
            {
              path: "valueandgiftvoucher/:id",
              element: <ValueandGiftVoucher />,
              errorElement: <RouterErrorPage />,
            },
            {
              path: "spacificvoucher/:id",
              element: <SpacificVoucher />,
              errorElement: <RouterErrorPage />,
            },
          ],
        },
        {
          path: "memberdirectory",
          element: <Memberlisting />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "adminhandles",
          element: <Navigate to="/admindashboard/handles" replace />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "memberdetails",
          element: <Memberdetails />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "companylanding/:companyId/companyinvoicedetail/:id",
          element: <CompanyInvoiceDetail />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "invoices/invoiceDetail/:id",
          element: <InvoiceDetail />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "invoices/invoicedetail/:id",
          element: <InvoiceDetail />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "companylanding/:id/user/:uid",
          element: <RolesAndPermissionPerticular />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "trash",
          element: <ProductTrash />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "producttrash",
          element: <ProductTrash />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "genie",
          element: <GenieAdmin />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "geniecategory",
          element: <GenieCategory />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "genieneedlist",
          element: <GenieNeedList />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "genieneactiveinactive",
          element: <GenieActiveInavtive />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "genienebingodeals",
          element: <GenieBingoDeals />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "allexternalapi",
          element: <AllExternalApi />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "signzydata",
          element: <SignzyData />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "vendorapiusage",
          element: <VendorApiUsage />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "pinelabsdata",
          element: <PineLabsData />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "pickrrdata",
          element: <PickrrData />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "allrecords",
          element: <AllRecords />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "admintrails",
          element: <Navigate to="/admindashboard/handles" replace />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "invoices",
          element: <Invoices />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "membershipinvoicelist",
          element: <MembershipList />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "membershiprenewal",
          element: <MembershipReneval />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "memamountdebitstatus",
          element: <MemAmountDebitStatus />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "commissioninvoicelist",
          element: <CommissionList />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "wishlist",
          element: <Wishlist />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "orders",
          element: <ProductOrders />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "notifications",
          element: <AdminNotifications />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "approvals",
          element: <Approvals />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "interests",
          element: <AllRecords />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "bxicommissionlist",
          element: <BXICommissionList />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "bwtdsdebitnotelist",
          element: <BWTDSDebitNoteList />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "bwtdsdebitnote/:id",
          element: <BWTDSDebitNoteDetail />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "bwtaxinvoicelist",
          element: <BrandWorldTaxInvoiceList />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "bwtaxinvoice/:id",
          element: <BrandWorldTaxInvoiceDetail />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "einvoiceView/:id/:type",
          element: <ViewInvoice />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "bwwallet",
          element: <BXIWallet />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "bwwallet_transactions",
          element: <BWWalletTransactions />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "seller-payouts",
          element: <SellerPayoutsReport />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "offline-payments",
          element: <OfflinePaymentsQueue />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "bw-beneficiaries",
          element: <BeneficiaryQueue />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "bw-payment-settings",
          element: <BrandWorldPaymentSettings />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "orderrequest/:id",
          element: <AdminOrderRequestDetail />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "performainvoice/:id",
          element: <AdminPerformaInvoiceView />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "performainvoice/:id/:orderId",
          element: <AdminPerformaInvoiceView />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "mediaproformainvoiceforbuyer/:id/:orderId",
          element: <MediaProformaInvoiceForBuyer />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "mediaproformainvoiceforseller/:id/:orderId",
          element: <MediaProformaInvoiceForSeller />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "performainvoice/:id/:orderId/choose-transport",
          element: <AdminChooseTransport />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "taxinvoice/:id",
          element: <AdminTaxInvoiceView />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "commissionByOrderId/:OrderId",
          element: <AdminCommissionInvoiceView />,
          errorElement: <RouterErrorPage />,
        },
      ],
    },
    {
      path: "home",
      element: <SideBar />,
      errorElement: <RouterErrorPage />,
      loader: checkAuthToken,
      children: [
        {
          path: "taxinvoice/:id",
          element: <AdminTaxInvoiceView />,
          errorElement: <RouterErrorPage />,
        },
        {
          path: "commissionByOrderId/:OrderId",
          element: <AdminCommissionInvoiceView />,
          errorElement: <RouterErrorPage />,
        },
      ],
    },
  ],

  {
    basename: `/`,
  }
);

const MainRouter = ({ children }) => {
  return (
    <React.Fragment>
      <RouterProvider router={routesData}>{children}</RouterProvider>
    </React.Fragment>
  );
};

export default MainRouter;
